import React, { ReactElement, useState } from 'react';
import { useParams } from 'react-router';
import './dropdownListButtons.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import routes from '../../../routing/routes';
import exportIcon from '../icons/export.svg';
import { downloadExportedFile } from '../../../client/exportClient';
import UserRole from '../../../model/currentuser/UserRole';
import Secured from '../../Secured';
import { useUserContext } from '../../../context/UserContext';
import { useSecurityContext } from '../../../context/SecurityContext';
import { useErrorMessageContext } from '../../../context/ErrorMessageContext';
import StadiumMaterialuEnum from '../../../model/currentuser/StadiumMaterialuEnum';
import { isAdmin, isAktualnyPredkladatel } from '../../../function/permissions';
import { isAuthorized } from '../../Secured/component/SecuredComponent';

interface Props {
  setOpenDropdown: (opened: boolean) => void;
}

const ExportPripomienokButton = ({ setOpenDropdown }: Props): ReactElement => {
  const {
    type, year, index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const { legislationProcess, pouzivatel } = useUserContext();
  const [disabled, setDisabled] = useState<boolean>(false);
  const { accessToken, organizationId } = useSecurityContext();
  const { displayError } = useErrorMessageContext();

  const handleClick = (): void => {
    downloadExportedFile(
      routes.export.pripomienkyOrg.withParams(
        type,
        year,
        index,
        pouzivatel.organizaciaUuid,
      ),
      'K materiálu nie je pridaná žiadna pripomienka za Vašu aktívnu organizáciu.',
      setDisabled,
      setOpenDropdown,
      accessToken,
      organizationId,
    ).then((errorMessage) => {
      if (errorMessage) {
        displayError(errorMessage);
      }
    });
  };

  const displayExportButton = (): boolean => {
    if (legislationProcess.stadiumProcesu) {
      if (StadiumMaterialuEnum.PRIPRAVA_MATERIALU === legislationProcess.stadiumProcesu) {
        return isAktualnyPredkladatel(pouzivatel, legislationProcess) || isAdmin(pouzivatel);
      }
      // eslint-disable-next-line max-len
      return isAuthorized([UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.PRIPOMIENKOVATEL, UserRole.ODOSIELATEL], pouzivatel);
    }

    return false;
  };

  return (
    <Secured
      additionalCheck={displayExportButton()}
    >
      <li key="Export pripomienok org." className="action-item">
        <div className="icon-wrapper">
          <img src={exportIcon} className="icon" alt="Export pripomienok org." />
        </div>
        <button
          disabled={disabled}
          type="button"
          className="export-pripomienok-button button-inline-text idsk-link"
          onClick={handleClick}
        >Export pripomienok organizácie
          {disabled ? <FontAwesomeIcon className="spinner" icon={faSpinner} spin /> : null}
        </button>
      </li>
    </Secured>
  );
};
export default ExportPripomienokButton;
